import { render, staticRenderFns } from "./yaoqing.vue?vue&type=template&id=48ff985e&scoped=true&"
import script from "./yaoqing.vue?vue&type=script&lang=js&"
export * from "./yaoqing.vue?vue&type=script&lang=js&"
import style0 from "./yaoqing.vue?vue&type=style&index=0&id=48ff985e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ff985e",
  null
  
)

export default component.exports